/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneQuotebox from 'base/components/standalone/Quotebox';

export const DynamicStandaloneQuotebox = StandaloneQuotebox;
export type DynamicStandaloneQuoteboxProps = PropsFromComponent<typeof StandaloneQuotebox>;

export const DynamicStandaloneQuoteboxWith = (extras: DynamicStandaloneExtras): typeof StandaloneQuotebox => {
    return function DynamicStandaloneQuotebox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Quotebox');
        return <StandaloneQuotebox {...mergeProps({ options: { theme } }, props)} />;
    }
}